import { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./UserComponent.module.css";
import { useNavigate } from "react-router";
import axios from "axios";
import { observer } from "mobx-react";
import config from "../../config/config";
import store from "../../Store/Store";
import { Pagination } from "antd";
import EditUserLimits from "./EditUserLimits/EditUserLimits";
import NewUsers from "./newUsers/NewUsers";
import Notificatio from "./Notification/Notificatio";
import companyStore from "../../Store/Store";
import TopUp from "./TopUp/TopUp";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";

const UserComponent = observer(({ className = "" }) => {
  const [data, setData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [serchFilter, setSerchFilter] = useState("");
  const [companyname, setcompanyname] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [flagNotifi, setFlagNotifi] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [refresh, setRefresh] = useState(true);
  const [editUser, setEdituser] = useState(false);
  const [EditTopUp, setEditTopUp] = useState(false);
  const [noData, setNoData] = useState(false);
  const [topUpNoti, settopUpNoti] = useState(false);
  const [isViewAdmin, setViewAdmin] = useState(false);
  const [isUser, setIsUser] = useState(false);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  useEffect(() => {
    store.setSelectedExpenseMobileNo("");
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }
    const obj = {
      ledger_label: store.Company_Id,
    };
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    const expired = isTokenExpired(parsedTokens.IdToken);
    if (expired) {
      parsedTokens = getNewTokens(parsedTokens);
    }
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_cupi_compnay_users`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    axios
      .request(payload)
      .then((res) => {
        setData(res.data.data);
        setcompanyname(res.data.company_name);
      })
      .catch((er) => {
        console.log(er);
      });
  }, [refresh, store.refresh]);

  const handlenavi = () => {
    navigate("/content/view-user");
  };

  const filteredData = data.filter(
    (user) =>
      (user?.name &&
        user?.name.toLowerCase().includes(serchFilter.toLowerCase())) ||
      (user?.mobile_no &&
        user?.mobile_no.toLowerCase().includes(serchFilter.toLowerCase())) ||
      (user?.tags &&
        user?.tags.toLowerCase().includes(serchFilter.toLowerCase())) ||
      (user?.email &&
        user?.email.toLowerCase().includes(serchFilter.toLowerCase())) ||
      (user?.roles && user?.roles.includes(serchFilter.toUpperCase())),
  );

  const startIndex = (currentPage - 1) * pageSize;
  let currentPageData = filteredData
    .reverse()
    .slice(startIndex, startIndex + pageSize);

  useEffect(() => {
    if (currentPageData.length < 1) {
      setNoData(true);
    } else {
      setNoData(false);
    }
  }, [currentPageData]);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const onAddNewUsersClick = useCallback(() => {
    setFlag(true);
  }, []);

  function OpenTopup(detail) {
    try {
      console.log("detail?----->", detail);

      store.setUserId(detail.user_id);
      store.setName(detail.name);
      store.setSelectedEmail(detail.email);
      store.setCreate_at(detail.create_at);
      store.setPhoneNo(detail?.mobile_no);
      store.setUserRoles(detail?.roles);
      console.log("detail?.topup_startdate", detail.topup_startdate);
      console.log(
        "hasTopup",
        detail?.topup_startdate != undefined &&
          detail.topup_enddate != undefined &&
          detail?.topup_startdate != "" &&
          detail.topup_enddate != "",
      );
      if (
        detail?.topup_startdate != undefined &&
        detail.topup_enddate != undefined &&
        detail?.topup_startdate != "" &&
        detail.topup_enddate != ""
      ) {
        console.log("topUp is available");

        store.setTopUpStatus(detail?.topup_status);
        store.setTopUpName(detail?.topup_name);
        store.setTopUpTotalLimit(detail?.topup_total_limit);
        store.setTopUpDailyLimit(detail?.topup_daily_limit);
        store.setTopUpNote(detail?.topup_note ? detail?.topup_note : "");
        store.setStartDate(detail?.topup_startdate);
        store.setEndDate(detail?.topup_enddate);
      } else {
        store.setTopUpStatus("");
        store.setTopUpName("");
        store.setTopUpTotalLimit("");
        store.setTopUpDailyLimit("");
        store.setTopUpNote("");
        store.setStartDate("");
        store.setEndDate("");
      }
      setEditTopUp(true);
    } catch (err) {
      console.log("error", err);
    }
  }

  return (
    <div className={styles.pageContainer + " " + className}>
      <div className={styles.frameParent}>
        <div className={styles.welcomesunshineinfotechWrapper}>
          <div className={styles.welcomesunshineinfotech}>
            {companyStore.userType == "AxisUser" &&
              !store.isUserViewAdmin &&
              !store.isUserGlobalViewAdmin && (
                <button
                  className={styles.addNewUsers}
                  onClick={() => {
                    navigate("/content/bulkUser");
                  }}
                >
                  <img
                    className={styles.plusCircleIcon}
                    alt=""
                    src="/Layer_14.svg"
                  />
                  <b className={styles.newUser}>Bulk users </b>
                </button>
              )}

            {companyStore.userType == "AxisUser" &&
              !store.isUserViewAdmin &&
              !store.isUserGlobalViewAdmin && (
                <button
                  className={styles.addNewUsers}
                  onClick={onAddNewUsersClick}
                >
                  <img
                    className={styles.plusCircleIcon}
                    alt=""
                    src="/pluscircle.svg"
                  />
                  <b className={styles.newUser}>New user</b>
                </button>
              )}
          </div>
        </div>
        <div className={styles.frameGroup}>
          <div className={styles.feeStatementDataTable}>
            <div className={styles.top}>
              <div className={styles.filterWrapper}>
                <div className={styles.filter}>
                  <div className={styles.containertext}> User List</div>{" "}
                </div>
                <div className={styles.filter}>
                  <div className={styles.textField}>
                    <div className={styles.content}>
                      <img
                        className={styles.leadingIcon}
                        alt=""
                        src="/leadingicon.svg"
                      />
                      <input
                        className={styles.labelText1}
                        placeholder="Search..."
                        type="text"
                        value={serchFilter}
                        onChange={(e) => {
                          setSerchFilter(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <button
                    className={styles.reLoadTable}
                    onClick={() => {
                      if (refresh) {
                        setRefresh(false);
                        return;
                      }
                      setRefresh(true);
                    }}
                  >
                    <img
                      className={styles.vectorIcon1}
                      alt=""
                      src="/vector7.svg"
                    />
                  </button>
                </div>
              </div>
              <div className={styles.topChild} />
            </div>
            <table className={styles.table}>
              <thead className={styles.tableHead}>
                <tr className={styles.tableHeaderRow}>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>NAME</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>PHONE NO</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>EMAIL</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`PER TXN LIMIT (₹)`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`DAILY LIMIT(₹)`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`MONTHLY LIMIT(₹)`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`Top-up status`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>{`ADMIN`}</div>
                  </th>
                  <th className={styles.tableHeaderRowCell}>
                    <div className={styles.head}>ACTION</div>
                  </th>
                </tr>
              </thead>
              <tbody className={styles.tableHead}>
                {currentPageData.map((detail, index) => (
                  <tr key={index} className={styles.tableBodyrow}>
                    <td
                      className={styles.tableBodydatabtn}
                      onClick={() => {
                        console.log("gotit");
                        store.setSelectedExpenseMobileNo(detail.mobile_no);
                        navigate("/content/transactions");
                      }}
                    >
                      <div className={styles.data12}>{detail?.name}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data1}>{detail?.mobile_no}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data1}>
                        {detail?.email == "undefined"
                          ? "-"
                          : detail?.email || "-"}
                      </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data}>{detail.perTxnLimit}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <div className={styles.data}> {detail.dailyLimit} </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data}>{detail.monthlyLimit}</div>
                    </td>
                    <td className={styles.tableBodydata}>
                      {" "}
                      <div className={styles.data}>
                        {detail?.topup_status || "inactive"}
                      </div>
                    </td>
                    <td className={styles.tableBodydata}>
                      <div className={styles.data}>
                        {detail.roles.includes("ADMIN") ||
                        detail.roles.includes("OWNER") 
                          ? "Yes"
                          : "No"}
                      </div>
                    </td>
                    <td className={styles.tableBodydata22}>
                      <button
                        className={styles.button}
                        onClick={() => {
                          store.setUserId(detail?.user_id);
                          store.setName(detail?.name);
                          store.setSelectedEmail(detail?.email);
                          store.setTxnLimit(detail?.perTxnLimit);
                          store.setDailyLimit(detail?.dailyLimit);
                          store.setmonthlyLimit(detail?.monthlyLimit);
                          store.setCreate_at(detail?.create_at);
                          store.setPhoneNo(detail?.mobile_no);
                          store.setStatus(detail?.status);
                          store.setEnabled(true);
                          store.setUserRoles(detail?.roles);
                          store.setTags(detail?.tags?.split(","));
                          if (companyStore.userType != "AxisUser") {
                            store.setUserHasWallet(detail?.has_wallet);
                            store.setUserKycInfo(detail?.kyc_info);
                          }

                          setEdituser(true);
                        }}
                      >
                        Edit
                      </button>
                      /
                      <button
                        className={styles.button1}
                        onClick={() => {
                          OpenTopup(detail);
                        }}
                      >
                        TopUp
                        {/* <img
                          alt=""
                          src="/edit-02.svg"
                          className={styles.btn_img}
                        /> */}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {noData && <div className={styles.noHistory}>No Users found .</div>}
            <div className={noData ? styles.bottom1 : styles.bottom}>
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={filteredData.length}
                onChange={handlePaginationChange}
                // showSizeChanger
              />
            </div>
          </div>
        </div>
      </div>
      <div></div>
      {editUser && (
        <div
          className={styles.ViewUserHeader}
          onClick={() => {
            // setEdituser(false);
          }}
        >
          <EditUserLimits
            isVisible={editUser}
            onClose={() => {
              setEdituser(false);
            }}
          />
        </div>
      )}
      {flag && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            // setFlag(false);
          }}
        >
          <NewUsers
            isVisible={flag}
            onClose={() => {
              setFlag(false);
            }}
            openNoti={() => {
              setFlagNotifi(true);
            }}
            setAdmin={() => {
              setIsAdmin(true);
            }}
            resetAdmin={() => {
              setIsAdmin(false);
            }}
            setViewAdmin={() => {
              setViewAdmin(true);
            }}
            setUserAccess={() => {
              setIsUser(true);
              console.log("NEW USER HAS BEEN ADDED");
            }}
          />
        </div>
      )}
      {EditTopUp && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            // setEditTopUp(false);
          }}
        >
          <TopUp
            isVisible={EditTopUp}
            onClose={() => {
              setEditTopUp(false);
            }}
            openNoti={() => {
              setFlagNotifi(true);
              settopUpNoti(true);
              if (refresh) {
                setRefresh(false);
              } else {
                setRefresh(true);
              }
            }}
          />
        </div>
      )}
      {console.log("in UserCOMPOnentisUser--------------",isUser)}
      {flagNotifi && (
        <div
          className={styles.newUsersOverlay1}
          onClick={() => {
            setFlagNotifi(false);

            settopUpNoti(false);
          }}
        >
          <Notificatio
            isAdmin={isAdmin}
            isVisible={flagNotifi}
            onClose={() => {
              setFlagNotifi(false);
            }}
            TopUpNoti={topUpNoti}
            isViewAdmin={isViewAdmin}
            isUser={isUser}
          />
        </div>
      )}
    </div>
  );
});

UserComponent.propTypes = {
  className: PropTypes.string,
};

export default UserComponent;
